/**
 * @generated SignedSource<<f93260a06a13bcbf20acbb5d12a45f16>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DownloadReportMutation$variables = {
  id: string;
};
export type DownloadReportMutation$data = {
  readonly downloadReport: {
    readonly displayName: string | null | undefined;
    readonly downloadLink: string | null | undefined;
    readonly downloadLinkExpiryDate: TimeScalar | null | undefined;
    readonly id: string;
  } | null | undefined;
};
export type DownloadReportMutation = {
  response: DownloadReportMutation$data;
  variables: DownloadReportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Report",
    "kind": "LinkedField",
    "name": "downloadReport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "downloadLink",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "downloadLinkExpiryDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DownloadReportMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DownloadReportMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7d7d533798254b420c2868eef8ed0e78",
    "id": null,
    "metadata": {},
    "name": "DownloadReportMutation",
    "operationKind": "mutation",
    "text": "mutation DownloadReportMutation(\n  $id: ID!\n) {\n  downloadReport(id: $id) {\n    id\n    downloadLink\n    downloadLinkExpiryDate\n    displayName\n  }\n}\n"
  }
};
})();

(node as any).hash = "68710ff4e401d15d8e62c26c6f05ef5d";

export default node;
